var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6399 27.8398L37.7399 25.4198L40.1599 24.3198L37.7399 23.2198L36.6399 20.7998L35.5399 23.2198L33.1199 24.3198L35.5399 25.4198L36.6399 27.8398Z",
    fill: "#EBD619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6399 33.1198L35.5399 35.5398L33.1199 36.6398L35.5399 37.7398L36.6399 40.1598L37.7399 37.7398L40.1599 36.6398L37.7399 35.5398L36.6399 33.1198Z",
    fill: "#EBD619"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0399 28.2798L27.8399 23.4398L25.6399 28.2798L20.7999 30.4798L25.6399 32.6798L27.8399 37.5198L30.0399 32.6798L34.8799 30.4798L30.0399 28.2798ZM28.7111 31.351L27.8399 33.2694L26.9687 31.351L25.0503 30.4798L26.9687 29.6086L27.8399 27.6902L28.7111 29.6086L30.6295 30.4798L28.7111 31.351Z",
    fill: "#EBD619"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    filter: "url(#filter0_f_1038_7468)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 8,
    fill: "#FFF8B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1038_7468",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_1038_7468"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.ad8cde65d0bd0f7a99cbcc1ec1007c1e.svg";
export { ForwardRef as ReactComponent };